import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createPortal } from "react-dom";
import SVG_CashoutIcon from "../../assets/images/svgs/cashout.svg?react";
import { setIsCashOutPopup } from "../../store/cashoutPopup/cashoutPopup.slice";
import { toastr } from "react-redux-toastr";
import { connectCashoutPopup } from "./CashoutPopup.connect";
const modalRoot = document.querySelector("#modal-root");

const CashoutPopup = ({ betPlacing, actions }) => {
  const dispatch = useDispatch();
  const cashoutPopup = useSelector((state) => state.cashoutPopUp);
  const auth = useSelector((state) => state.auth);

  const [isPlacing, setPlacing] = useState(false);
  const [timer, setTimer] = useState(0);

  useEffect(() => {
    if (timer && isPlacing) {
      const time = setInterval(() => {
        setTimer((timer) => timer - 1);
      }, 1000);
      return () => clearInterval(time);
    }
  }, [timer, isPlacing]);

  useEffect(() => {
    setTimer(betDelayLoader());
  }, [isPlacing]);

  function betDelayLoader() {
    let betDelay = 0;
    if (
      cashoutPopup?.market.marketType == "MATCH_ODDS" &&
      cashoutPopup?.market.eventTypeId == "4"
    ) {
      //Match Odds Cricket
      betDelay = parseInt(
        cashoutPopup?.market?.betDelay?.matchoddsBetDelay || 5
      );
    } else if (
      cashoutPopup?.market.marketType == "MATCH_ODDS" &&
      cashoutPopup?.market.eventTypeId == "1"
    ) {
      // Match Odds Football
      betDelay = parseInt(cashoutPopup?.market?.betDelay?.soccerBetDelay || 5);
    } else if (
      cashoutPopup?.market.marketType == "MATCH_ODDS" &&
      cashoutPopup?.market.eventTypeId == "2"
    ) {
      // Match Odds Tennis
      betDelay = parseInt(cashoutPopup?.market?.betDelay?.tennisBetDelay || 5);
    } else if (cashoutPopup?.market.marketType == "Special") {
      // Bookmaker
      betDelay = parseInt(
        cashoutPopup?.market?.betDelay?.bookmakerBetDelay || 5
      );
    } else if (cashoutPopup?.market.marketType == "SESSION") {
      // Session
      betDelay = parseInt(cashoutPopup?.market?.betDelay?.fancyBetDelay || 5);
    } else if (cashoutPopup?.market.eventTypeId == "v9") {
      // Virtual
      betDelay = parseInt(cashoutPopup?.market?.betDelay?.virtualBetDelay || 5);
    } else if (cashoutPopup?.market.eventTypeId == "b9") {
      betDelay = parseInt(
        cashoutPopup?.market?.betDelay?.ballbyballBetDelay || 5
      );
    } else {
      betDelay = 5;
    }
    return betDelay;
  }

  const submit = async () => {
    setPlacing(true);
    actions.setBetPlacingPopoverStage(true);
    actions
      .requestSetOrder(betPlacing)
      .then((res) => {
        if (res?.data) {
          if (res?.data?.status) {
            toastr.success("", "Cash-out successful");
            actions.setIsCashOut(false);
            actions.setCashOutId(null);
          } else {
            toastr.error("", res?.data?.msg);
          }
        }
        actions.requestOpenBets();
        actions.requestUnMatchedBets();

        actions.setShowBetPlacingPopover(false);
        actions.setMarket();
        // cancel()
        setPlacing(false);
        dispatch(setIsCashOutPopup({ isOpen: false, market: null }));
      })
      .catch((e) => {
        // cancel()
        actions.setShowBetPlacingPopover(false);
        setPlacing(false);
        actions.setMarket();
        dispatch(setIsCashOutPopup({ isOpen: false, market: null }));
        if (e[0] && e[0][0] && e[0][0].msg) toastr.error("", e[0][0].msg);
        else toastr.error("", e?.msg);
      });
  };

  return createPortal(
    <>
      {cashoutPopup?.isOpen && (
        <div
          id="popup-modal"
          className="z-[1000] absolute top-0 right-[0.5px] md:right-0 overflow-hidden flex w-full h-screen min-h-[100dvh]     items-center justify-center  bg-bg_CasinoPopupBg"
        >
          <div className="z-2 popUpBoxShadow popUpOpenAnimation  absolute  w-[90%] max-w-[350px] z-[900] bg-bg_Quaternary p-2 xs:p-5  rounded-md">
            <div className=" flex flex-col gap-1 align-top items-center gap-y-5 text-[14px]">
              <span className=" text-text_Ternary  font-[450]">
                <SVG_CashoutIcon />
              </span>
              <span className=" text-text_Ternary  font-medium font-lato leading-4 text-sm">
                Do you wish to perform cash out?
              </span>
              <div className=" grid grid-cols-2 w-full gap-x-2">
                <button
                  type="button"
                  className=" leading-normal relative overflow-hidden  transition duration-150 ease-in-out  bg-transperent w-full px-2.5 py-1 border-[1px] border-primary rounded-[4px] flex items-center justify-center  cursor-pointer "
                  onClick={() => {
                    setPlacing(false);
                    actions.setMarket();
                    dispatch(
                      setIsCashOutPopup({ isOpen: false, market: null })
                    );
                  }}
                >
                  <span className="text-text_Primary text-[16px] font-[700] font-lato ">
                    Cancel
                  </span>
                </button>
                <div className="w-full">
                  <button
                    type="button"
                    className="  leading-normal relative overflow-hidden  transition duration-150 ease-in-out  bg-cashout-btn-gradient w-full h-[36px] min-h-[36px]  px-2.5 py-1 border-[1px] border-success rounded-[4px] flex items-center justify-center  cursor-pointer"
                    onClick={() => {
                      submit();
                    }}
                  >
                    <span className="text-text_Quaternary text-[16px] font-[700] font-lato ">
                      Cashout
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {isPlacing && (
            <div className="z-3 popUpBoxShadow popUpOpenAnimation  absolute  w-[95%] max-w-[350px] z-[900] bg-bg_Quaternary p-2 xs:p-5  rounded-md">
              <div className=" flex flex-col gap-1 align-top items-center ">
                <span className=" relative w-max min-w-6 min-h-6 flex items-center justify-center p-2 pt-6 ">
                  <span className=" absolute min-w-14 min-h-14 animate-spin rounded-full border-[2px] border-primary border-dashed"></span>
                  <span className="font-semibold text-white ">
                    {timer}
                  </span>
                </span>
                <span className=" font-semibold text-white mt-[4px]">
                  Your cashout is being processed...
                </span>
                <span className="text-white font-semibold">Please Wait...</span>
              </div>
            </div>
          )}
        </div>
      )}
    </>,
    modalRoot
  );
};

export default connectCashoutPopup()(CashoutPopup);
